<h1>Edit {{discussionTitle}}</h1>

<section class="form">
  <app-input [ctx]="form.title"></app-input>

  <div class="three" *ngIf="isPlainArticle">
    <app-select [ctx]="form.category"></app-select>
    <app-select [ctx]="form.ageGroup"></app-select>
    <app-select [ctx]="form.access"></app-select>
  </div>
</section>

<app-editor [ctx]="form.text" class="editor"></app-editor>

<app-message-docs *ngIf="isPlainArticle" [ctx]="docs" [editable]="discussion" class="docs"></app-message-docs>

<button class="app-action-btn" [disabled]="(form.group.statusChanges | async) === 'INVALID'" (click)="save()"
  >Publish</button
>
